import camelCase from 'camelcase';
import _uniqBy from 'lodash.uniqby';

import type { FilingTypeOptions, PeriodApi } from '@api/filingTypes';
import { submissionPeriodsSetModel } from '@models/SubmissionPeriods/submissionPeriodsSet';

/**
 * Generates a list of filing types options from API data
 */
export const filingTypesOptionsSetModel = (
  options = [] as Array<PeriodApi>
): Array<FilingTypeOptions> =>
  _uniqBy(
    options.map(({ filingType, supportedUserExperiences }) => ({
      id: filingType.id,
      name: filingType.nameLong,
      submissionPeriods: submissionPeriodsSetModel(options, filingType.id),
      supportedUserExperiences: supportedUserExperiences.map(exp => camelCase(exp)),
    })),
    'id'
  ) as Array<FilingTypeOptions>;
